module.exports = __webpack_public_path__ + "img/green_button_bg_big.37320050.png";